export const cleanForm = (formId) => {
  localStorage.removeItem(formId)
}

export const saveForm = (formId, data) => {
  const jsonData = JSON.stringify(data)
  localStorage.setItem(formId, jsonData)
}

export const loadForm = (formId) => {
  try {
    return JSON.parse(localStorage.getItem(formId) ?? '')
  } catch (error) {
    // console.log("load error :")
    // console.log(error)
    return null
  }
}
